import type { TextProps } from "react-native";

import { Text } from "../../../mads";

import React, { Fragment } from "react";

export interface MarkupComponentsProps {
  /**
   * A map of components to interpolate.
   */
  components: Record<string, (children: string) => React.ReactNode>;

  /**
   * String to be translated
   */
  children: string;

  /**
   * Style to be applied to the text
   */
  textStyle?: TextProps["style"];
}

const re = new RegExp("\\[([^\\]]+)\\]", "g");

export const MarkupComponents = (props: MarkupComponentsProps): React.JSX.Element => {
  const children: React.ReactNode[] = [];
  const messageParts = props.children.split(re);

  for (let i = 0; i < messageParts.length; i++) {
    const elem = messageParts[i];

    if (i % 2 === 0) {
      children.push(
        <Fragment key={`key_${i}`}>
          <Text sx={props.textStyle}>{elem}</Text>
        </Fragment>,
      );
      continue;
    }

    const parts = elem.split("|");
    const key = parts.pop() as string;
    const text = parts.length ? parts.join("|") : null;

    const component = props.components[key];

    // If component is a function, then we have a function which will return a React element (aka 'render prop')
    if (typeof component === "function") {
      children.push(<Fragment key={`${key}_${i}`}>{component(text || "")}</Fragment>);
      continue;
    }

    // If component wasn't found (could be a key missing from `components` record)
    children.push(
      <Fragment key={`${key}_${i}`}>
        <Text sx={props.textStyle}>{text}</Text>
      </Fragment>,
    );
  }

  return <Fragment>{children}</Fragment>;
};
